export default __webpack_public_path__ + "0af5252211aa50e0f5f2683a4181257e.svg";